module.exports = __webpack_public_path__ + "static/img/lt.39f9399a.svg";